import { emphasize } from "@material-ui/core";

export const colors = {
  // Style Guide Colors
  backgroundGray: 'rgb(249,249,249)',
  sidebarBackgroundGray: 'rgb(252,252,252)',
  battleshipGrey: 'rgb(107,126,134)', // cool name 😎
  dodgerBlue: 'rgb(65,132,243)',
  gunmetal: 'rgb(67,74,89)',
  gunmetalTwo: 'rgb(74,81,95)',
  warmGray: 'rgb(151,151,151)',
  primaryColor: 'rgb(58,100,49)', // pine green
  primaryHighlight: '#ecf5fe',
  primaryAccent: '#596097',
  secondaryColor: 'rgb(215,98,35)', // brownish orange
  secondaryAccent: 'rgb(255,170,69)', //light orange
  darkAccent: '#3c3d3f',
  highlightBright: '#edeef0',
  highlightMedium: '#b8c5d0',
  highlightDark: '#9da4ad',
  highlightDarker: '#3c4c65',
  successGreen: '#4eda1f',
  errorRed: '#dc3636',
  white: '#ffffff',
  leafGreen: '#5dac08',
  lightOrange: '#ffaa45',
  squash: '#eea321',
  tomato: '#ef4836',
  charcoalGrey: '#42424e',
  purpleGrey: '#8f8e94',
};

export const baseStyles = {
  container: {
    backgroundAttachment: 'scroll',
    backgroundRepeat: 'repeat',
    height: '100%',
    minHeight: '900px',
    padding: '10px',
  },
  loginBox: {
    margin: '0 auto 100px',
    textAlign: 'center',
    width: '500px',
  },
  errorText: {
    color: colors.secondaryAccent,
    height: '18px',
    paddingTop: '18px',
  },
  form: {
    margin: 'auto',
    padding: '35px 50px 50px',
  },
  link:{
    color: "#27b1e8",
    cursor:"pointer", 
  },
  linkHover:{
    cursor:"pointer",
    textDecoration:"underline",
    color: "#0000D6",
    
  }

};

export const clinicBaseStyles = {
  btnHeight: {
    marginTop: '20px',
  },
  btnLabel: {
    fontSize: '18px',
    color: colors.white,
  },
  btnStyle: {
    backgroundColor: colors.secondaryColor,
  },
  container: {
    backgroundAttachment: 'scroll',
    height: '100%',
    minHeight: '900px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  headerImg: {
    height: '180px',
    paddingBottom: '30px',
    width: '180px',
    marginTop: '10%',
  },
  labelStyle: {
    color: colors.white,
    fontSize: '16px',
    width: 'auto',
  },
  selectedMenuItemStyle: {
    color: colors.primaryColor,
  },
  selectField: {
    textAlign: 'center',
    width: '65%',
    maxWidth: '400px',
    margin: '10px',
  },
  white: {
    color: colors.white,
    textAlign: 'center',
  },
};

export const adminBaseStyles = {
  alignment: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh'
    
  },
  layout: {
    backgroundColor: colors.backgroundGray,
    borderTop: "5px solid rgb(58,100,49)",
    height: 'fit-content',
    display: 'flex',
    width: 'fit-content',
    minWidth: '100%',
    minHeight:'100%'
  }
};


export const adminSidebaseStyles = {
  alignLinks: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignSelf: 'center',
    marginRight: '2rem',
    marginLeft: '2rem',
    marginTop: '1rem',
    cursor: "pointer",
  },
  inActiveLink:{
    backgroundColor:'#102abc',
    color:'#f2e1e1'
  },
  btn: {
    width: '11rem',
    marginTop: '4rem',
    marginBottom: '4rem',
  },
  icon: {
    color: colors.battleshipGrey,
    marginRight: '2rem',
    cursor: 'pointer',
    height:"0.8cm"
  },
  linkIcon: {
    color: colors.battleshipGrey,
    marginRight: '2rem',
    cursor: 'pointer',
    height:30,
    width:35
  },
  linked: {
    color: colors.battleshipGrey,
    textDecoration: 'none',
  },
  links: {
    color: colors.battleshipGrey,
    fontSize: '.75rem',
    minWidth: '12rem',
    maxWidth: '14rem',
  },
  links2: {
    color: colors.battleshipGrey,
    fontSize: '.75rem',
    minWidth: '12rem',
    maxWidth: '14rem',
    marginTop: '10rem',
    marginBottom: '5vh',
  },
  logo: {
    marginBottom: '2rem',
    marginTop: '1.5rem',
  },
  sidebar: {
    width: '12rem',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: colors.sidebarBackgroundGray,
  },
  hoverLink: {
    cursor: 'pointer',
  }
};

export const patientItemBaseStyles = {
  action: {
    color: 'rgb(255,170,69)',
  },
  cancel: {
    color: 'rgb(255,99,99)',
  },
  row: {
    backgroundColor: '#fff',
  },
  avatar: {
    height: '40px',
    width: '40px',
    borderRadius: '50%',
  },
};

export const adminPanelBaseStyles = {
  action: {
    color: 'rgb(255,170,69)',
  },
  body: {
    marginTop: '5px',
  },
  cancel: {
    color: 'rgb(255,99,99)',
  },
  center: {
    display: 'flex',
    alignItems: 'center',
  },
  footer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '1rem',
    padding: '2rem',
  },
  footerColors: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    width: '7rem',
  },
  row: {
    backgroundColor: '#fff',
  },
  select: {
    width: '8rem',
    border: 'none',
  },
  table: {
    width: '75vw',
  },
  tableAlign: {
    display: 'flex',
    flexDirection: 'column',
  },
  top: {
    marginRight: '2rem',
    marginLeft: '1.5rem',
  },
};

export const patientListBaseStyles = {
  container: {
    minWidth: '768px',
    paddingLeft: '20px',
  },
  dropDownSortIcon: {
    color: colors.lightGreyText,
    height: '2rem',
    verticalAlign: 'middle',
  },

  headerTitle: {
    fontWeight: 100,
    fontSize: '1.4rem',
  },
  table: {
    width: '75vw',
  },
  tableLabels: {
    whiteSpace: 'nowrap',
  },
}

export const patientGoalBaseStyles = {
  textField: {
    margin: '10px',
  },
  container: {
  },
  navstyle: {
    gridArea: 'navstyle',
  },
  patientName: {
    gridArea: 'patientName',
    alignSelf: 'end',
  },
  startDate: {
    color: colors.purpleGrey,
    gridArea: 'startDate',
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'end',
  },
  today: {
    color: colors.purpleGrey,
    gridArea: 'todaysDate',
    display: 'flex',
    flexDirection: 'column',
    justifySelf: 'center',
    alignSelf: 'end',
  },
  upload: {
    gridArea: 'upload',
    justifySelf: 'center',
    alignSelf: 'center',
  },
  xray: {
    gridArea: 'image',
    marginTop: '1rem',
    justifySelf: 'center'
  },
};

export const compilanceStyles = {
  chartWrapper: {
    // width: 500,
    // height: 300
    width: 250,
    height: 150

  },
  
  container: {
    gridArea: 'complianceTable',
  },
};

export const autoCompleteStyles = theme => ({
  root: {
      flexGrow: 1,
      width: '12rem',
  },
  input: {
      display: 'flex',
      color: 'white',
      padding: 0,
      width: '12rem',
  },
  valueContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      flex: 1,
      alignItems: 'center',
      overflow: 'hidden',
  },
  chip: {
      margin: `${theme.spacing(1/ 2)}px ${theme.spacing(1/ 4)}px`,
  },
  chipFocused: {
      backgroundColor: emphasize(
          theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
          0.08,
      ),
  },
  noOptionsMessage: {
      padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
  },
  singleValue: {
      fontSize: 16,
  },
  placeholder: {
      color: 'black',
      position: 'absolute',
      left: 2,
      fontSize: 16,
  },
  paper: {
      position: 'absolute',
      zIndex: 1,
      marginTop: theme.spacing(1),
      left: 0,
      right: 0,
      width: '20rem',
  },
  divider: {
      height: theme.spacing( 2),
  },
});

export const selectStyles = {
  container: () => ({
      width: '12rem',
  })
}


export const loadingStyle = {
  width: 50,
  margin: '10rem auto',
  height: 600,
};

export const patientDetailsStyles = {
  message:{
    fontSize: 16,
    fontWeight: 'bold',
    marginTop: "2rem",
    marginBottom: "2rem",

    
  },
  flexContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    fontSize:40 ,
    textDecoration: 'underline',
  },
  birthDate: {
    marginLeft: '2rem',
    marginTop: '1.5rem',
  },
  dataUploads: {
    marginLeft: '2rem',
    marginTop: '1rem',
  },
  textField: {
    margin: '10px',
  },
  patientName: {
    gridArea: 'patientName',
    alignSelf: 'end',
  },
  startDate: {
    color: colors.purpleGrey,
    marginLeft: 13
    // gridArea: 'startDate',
    // display: 'flex',
    // flexDirection: 'column',
    // alignSelf: 'end',
  },
  table: {
    width: '700px',
  },
  today: {
    color: colors.purpleGrey,
    gridArea: 'todaysDate',
    display: 'flex',
    flexDirection: 'column',
    justifySelf: 'center',
    alignSelf: 'end',
  },
  upload: {
    gridArea: 'upload',
    justifySelf: 'center',
    alignSelf: 'center',
  },
  xray: {
    gridArea: 'image',
    marginTop: '1rem',
    justifySelf: 'center'
  },
};